import { get } from '../feathersWrapper';

export function getJournalScopeValidationError(journal) {
  const scopeId = journal?.journalScopeSelect?.id;
  if (scopeId === 'Property/Unit' && !journal?.propertyIdSelect?.id) {
    return 'Please select a property';
  }
  if (scopeId === 'Sub-Portfolio' && !journal?.entityIdSelect?.id) {
    return 'Please select a sub-portfolio';
  }
  return null;
}

export function getJournalScopeProperties(journal) {
  const journalScopeProperties = {
    unitId: null,
    propertyId: null,
    entityId: null,
  };

  const scopeId = journal?.journalScopeSelect?.id;

  if (scopeId === 'Portfolio') {
    journalScopeProperties.unitId = null;
    journalScopeProperties.propertyId = null;
    journalScopeProperties.entityId = null;
  } else if (scopeId === 'Sub-Portfolio') {
    journalScopeProperties.unitId = null;
    journalScopeProperties.propertyId = null;
    journalScopeProperties.entityId = journal?.entityIdSelect?.id ?? null;
  } else if (scopeId === 'Property/Unit') {
    journalScopeProperties.propertyId = journal?.propertyIdSelect?.id ?? null;
    journalScopeProperties.entityId = journal?.propertyIdSelect?.entityId ?? null;
    if (journal?.propertyIdSelect?.unitSelection === 'multi' && journal?.unitIdSelect?.id !== 'All') {
      journalScopeProperties.unitId = journal?.unitIdSelect?.id ?? null;
    } else {
      journalScopeProperties.unitId = null;
    }
  }

  return journalScopeProperties;
}

export const setJournalScope = (journal) => {
  const scopeId = journal?.journalScopeSelect?.id;

  if (scopeId === 'Portfolio') {
    journal.unitId = null;
    journal.propertyId = null;
    journal.entityId = null;
  } else if (scopeId === 'Sub-Portfolio') {
    journal.unitId = null;
    journal.propertyId = null;
    journal.entityId = journal?.entityIdSelect?.id ?? null;
  } else if (scopeId === 'Property/Unit') {
    journal.propertyId = journal?.propertyIdSelect?.id ?? null;
    journal.entityId = journal?.propertyIdSelect?.entityId ?? null;
    if (
      journal?.propertyIdSelect?.unitSelection === 'multi' &&
      journal?.unitIdSelect?.id !== 'All' &&
      journal?.unitIdSelect?.id !== 'All Units'
    ) {
      journal.unitId = journal?.unitIdSelect?.id ?? null;
    } else {
      journal.unitId = null;
    }
  }
};

export const setInitialJournalScope = async (journal, component) => {
  const { organizationName } = component.context;

  if (journal.unitId) {
    const unit = await get(this, 'units', journal.unitId);
    journal.propertyIdSelect = unit.property;
    journal.unitIdSelect = unit;
    journal.journalScopeSelect = { name: 'Property/Unit', id: 'Property/Unit' };
  } else if (journal.propertyId) {
    const property = await get(this, 'properties', journal.propertyId);
    if (property.unitSelection === 'multi') {
      journal.unitIdSelect = { name: 'All Units', id: 'All' };
    }
    journal.propertyIdSelect = property;
    journal.journalScopeSelect = { name: 'Property/Unit', id: 'Property/Unit' };
  } else if (journal.entityId) {
    const entity = await get(this, 'entities', journal.entityId);
    journal.entityIdSelect = entity;
    journal.journalScopeSelect = { name: 'Sub-Portfolio', id: 'Sub-Portfolio' };
  } else {
    journal.journalScopeSelect = { name: `${organizationName} Portfolio`, id: 'Portfolio' };
  }
};
